import { useTypedSelector } from "../hooks";
import { ApplicationInfo } from "../slices/applicationSlice";

export const useApplication = (): ApplicationInfo => {
  const state = useTypedSelector(({ _application }) => _application);
  return state;
};
